import React, { useEffect, useState } from "react";
import editIcon from "../../assets/icons/editIcon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { updatePermission } from "../../apis/rolesAndPermissionsApi/rolesAndPermissionsApi";
import CircularProgress from '@mui/material/CircularProgress';


const PermissionActions = ({
  record,
  roleId,
  setEditPermissionId,
  editPermissionData,
  setEditPermissionData,
  permissionDataInitialState,
  refreshPermissions
}: any) => {
  const [loading,setLoading]=useState(false);
  const [showEditIcon, setShowEditIcon] = useState(true);
  const [showActionIcons, setShowActionIcons] = useState(false);

  const handleEdit = () => {
    setEditPermissionId(record.Permission_Id);
    const permissionData = {
      Create_Flg: record.Create_Flg,
      Read_Flg: record.Read_Flg,
      Update_Flg: record.Update_Flg,
      SoftDelete_Flg: record.SoftDelete_Flg,
    };
    setEditPermissionData(permissionData);
    setShowEditIcon(false);
    setShowActionIcons(true);
  };
  const cancel = () => {
    setEditPermissionId(-1);
    setShowEditIcon(true);
    setShowActionIcons(false);
    setEditPermissionData(permissionDataInitialState);
  };
  const handleEditSubmit = () => {
    setLoading(true);
    let payload = editPermissionData;
    payload.Role_Id = roleId;
    payload.Permission_Id = record.Permission_Id;

    updatePermission(payload, (res: any) => {
      if (res) {
        refreshPermissions();
        setEditPermissionData(permissionDataInitialState);
        setEditPermissionId(-1);
        setShowEditIcon(true);
        setShowActionIcons(false);
      }
      setLoading(false);
    });
  };

  return (
    <>
      <div>
        {loading && <CircularProgress color="inherit" size={'1rem'}  />}
        {showEditIcon && !loading && (
          <div onClick={handleEdit}>
            <img src={editIcon} width={15} />
          </div>
        )}
        {showActionIcons && !loading && (
          <div className="d-flex">
            <FontAwesomeIcon
              onClick={cancel}
              className="pd-md"
              icon={["fas", "xmark"]}
              color="black"
              size="lg"
            />
            <FontAwesomeIcon
              onClick={handleEditSubmit}
              className="pd-md"
              icon={["fas", "check"]}
              color="black"
              size="lg"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PermissionActions;
